// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Loader_ProseMirror__3OpCK","loader":"Loader_loader__3kRgd","loader__item":"Loader_loader__item__1Ltxh"};